<div id="main" class="notranslate">

   <!-- Banner: Above -->
   <ng-container *ngIf="fuseConfig.layout.banner && fuseConfig.layout.banner.position === 'above'">
    <ng-container *ngTemplateOutlet="banner"></ng-container>
  </ng-container>
  <!-- / Banner: Above -->

  <!-- TOOLBAR: Above -->
  <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'above'">
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  </ng-container>
  <!-- / TOOLBAR: Above -->

  <div id="container-1" class="container">

    <!-- NAVBAR: Left -->
    <ng-container *ngIf="fuseConfig.layout.navbar.position === 'left'">
      <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
    </ng-container>
    <!-- / NAVBAR: Left -->

    <div id="container-2" class="container">

      <!-- TOOLBAR: Below fixed -->
      <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'below-fixed'">
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      </ng-container>
      <!-- / TOOLBAR: Below fixed -->

      <div id="container-3" class="container" fusePerfectScrollbar
        [fusePerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}">

        <!-- TOOLBAR: Below static -->
        <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'below-static'">
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        </ng-container>
        <!-- / TOOLBAR: Below static -->
        <!--Breadcrumb-->
        <app-platform-breadcrumb [style.display]="fuseConfig.layout.breadcrumb ? 'block' : 'none'">
        </app-platform-breadcrumb>
        <!-- CONTENT -->
        <content></content>
        <!-- / CONTENT -->

        <!-- FOOTER: Below static -->
        <ng-container *ngIf="fuseConfig.layout.footer.position === 'below-static'">
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        </ng-container>
        <!-- / FOOTER: Below static -->

      </div>

      <!-- FOOTER: Below fixed -->
      <ng-container *ngIf="fuseConfig.layout.footer.position === 'below-fixed'">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      </ng-container>
      <!-- / FOOTER: Below fixed -->

    </div>

    <!-- NAVBAR: Right -->
    <ng-container *ngIf="fuseConfig.layout.navbar.position === 'right'">
      <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
    </ng-container>
    <!-- / NAVBAR: Right -->


     <!-- Chat panel -->
    <ng-container *ngIf="showChatPanel">
      <ng-container *ngTemplateOutlet="chatPanel"></ng-container>
    </ng-container>
    <!-- Chat panel -->

  </div>

  <!-- FOOTER: Above -->
  <ng-container *ngIf="fuseConfig.layout.footer.position === 'above'">
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </ng-container>
  <!-- FOOTER: Above -->

</div>


<!-- Chat panel -->
<ng-template #chatPanel>
  <fuse-sidebar name="chatPanel" position="right" class="chat-panel right-chat-panel" [folded]="true" [foldedWidth]="70"
  [foldedAutoTriggerOnHover]="false" lockedOpen="gt-md">
  <fuse-chat-panel-dynamic [RefChatPanelComponent]="chatPanelComponent"></fuse-chat-panel-dynamic>
</fuse-sidebar>
</ng-template>
<!-- Chat panel -->


<!-- Default SIDE PANEL -->
<ng-container *ngIf="fuseConfig?.layout?.sidepanel?.isOverlay">
  <fuse-sidebar name="defaultPanel"></fuse-sidebar>
</ng-container>
<!-- / Default SIDE PANEL -->


<!-- SIDE PANEL -->
<ng-container *ngIf="!fuseConfig.layout.sidepanel.hidden">
  <fuse-sidebar
  id="sidePanel-container"
  name="sidePanel"
  [position]="fuseConfig.layout.sidepanel.position"
  [folded]="fuseConfig.layout.sidepanel.folded"
  [foldedWidth]="fuseConfig.layout.sidepanel.foldedWidth"
  [foldedAutoTriggerOnHover]="fuseConfig.layout.sidepanel.foldedAutoTriggerOnHover"
  [lockedOpen]="fuseConfig.layout.sidepanel.lockedOpen">
    <side-panel-dynamic [RefSidePanelComponent]="sidePanelComponent"></side-panel-dynamic>
  </fuse-sidebar>
</ng-container>
<!-- / SIDE PANEL -->

<!-- QUICK PANEL -->
<fuse-sidebar name="quickPanel" position="right" class="quick-panel" [invisibleOverlay]="fuseConfig.layout.quickpanel?.invisibleOverlay" *ngIf="!fuseConfig.layout.quickpanel.hidden">
  <quick-panel *ngIf="!hasDynamicQuickPanel"></quick-panel>
  <quick-panel-dynamic [RefQuickPanelComponent]="quickPanelComponent" *ngIf="hasDynamicQuickPanel">
  </quick-panel-dynamic>
</fuse-sidebar>
<!-- / QUICK PANEL -->

<!-- Banner -->
<ng-template #banner>
  <toolbar-dynamic *ngIf="fuseConfig.layout.banner && !fuseConfig.layout.banner.hidden"
    [RefToolbarComponent]="bannerComponent">
  </toolbar-dynamic>
</ng-template>
<!-- / Banner -->

<!-- TOOLBAR -->
<ng-template #toolbar>
  <toolbar *ngIf="!fuseConfig.layout.toolbar.hidden && !hasDynamicToolbar"
    [ngClass]="fuseConfig.layout.toolbar.customBackgroundColor === true ? fuseConfig.layout.toolbar.position + ' ' + fuseConfig.layout.toolbar.background : fuseConfig.layout.toolbar.position"
    [userInfo]="userInfo">
  </toolbar>
  <toolbar-dynamic *ngIf="!fuseConfig.layout.toolbar.hidden && hasDynamicToolbar"
    [ngClass]="fuseConfig.layout.toolbar.customBackgroundColor === true ? fuseConfig.layout.toolbar.position + ' ' + fuseConfig.layout.toolbar.background : fuseConfig.layout.toolbar.position"
    [RefToolbarComponent]="toolbarComponent">
  </toolbar-dynamic>
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
  <footer *ngIf="!fuseConfig.layout.footer.hidden && !hasDynamicFooter"
    [ngClass]="fuseConfig.layout.footer.customBackgroundColor === true ? fuseConfig.layout.footer.position + ' ' + fuseConfig.layout.footer.background : fuseConfig.layout.footer.position">
  </footer>
  <footer-dynamic *ngIf="!fuseConfig.layout.footer.hidden && hasDynamicFooter"
    [ngClass]="fuseConfig.layout.footer.customBackgroundColor === true ? fuseConfig.layout.footer.position + ' ' + fuseConfig.layout.footer.background : fuseConfig.layout.footer.position"
    [RefFooterComponent]="footerComponent">
  </footer-dynamic>
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
  <fuse-sidebar name="navbar" class="navbar-fuse-sidebar" [folded]="fuseConfig.layout.navbar.folded" lockedOpen="gt-md"
    *ngIf="!fuseConfig.layout.navbar.hidden">
    <navbar [variant]="fuseConfig.layout.navbar.variant" class="left-navbar"
      [ngClass]="fuseConfig.layout.navbar.background" [userInfo]="userInfo"></navbar>
  </fuse-sidebar>
</ng-template>
<!-- / LEFT NAVBAR -->

<!-- RIGHT NAVBAR -->
<ng-template #rightNavbar>
  <fuse-sidebar name="navbar" position="right" class="navbar-fuse-sidebar" [folded]="fuseConfig.layout.navbar.folded"
    lockedOpen="gt-md" *ngIf="!fuseConfig.layout.navbar.hidden">
    <navbar [variant]="fuseConfig.layout.navbar.variant" class="right-navbar" [userInfo]="userInfo"></navbar>
  </fuse-sidebar>
</ng-template>
<!-- / RIGHT NAVBAR -->


<!-- Zoom Control -->
<app-device-zoom-control *ngIf="isZoomControl"></app-device-zoom-control>
